import { render, staticRenderFns } from "./FormBrokers.vue?vue&type=template&id=4d55c46c&"
import script from "./FormBrokers.vue?vue&type=script&lang=js&"
export * from "./FormBrokers.vue?vue&type=script&lang=js&"
import style0 from "./FormBrokers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports